import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { InsertPayment } from "../lib/supabase";
import { useAuth } from "../contexts/AuthContext";
import SmartBackButton from "../components/ui/SmartBackButton";
import toast from "react-hot-toast";
import { ENTITY_NAMES } from "../constants/entities";
import PaymentForm from "../components/payments/PaymentForm";

const AddPayment: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { userRole } = useAuth();
  const navigate = useNavigate();

  const isAdmin = userRole === "admin";

  if (!isAdmin) {
    return (
      <div className="text-center py-12">
        <h3 className="mt-2 text-sm font-medium text-gray-900">
          Access Denied
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Only administrators can add payments.
        </p>
      </div>
    );
  }

  const handleSubmit = async (data: InsertPayment) => {
    try {
      setIsLoading(true);

      const { error } = await supabase.from("payments").insert([data]);

      if (error) throw error;

      toast.success(`${ENTITY_NAMES.PAYMENT} created successfully`);
      navigate("/payments");
    } catch (error) {
      console.error("Error creating payment:", error);
      toast.error(`Failed to create ${ENTITY_NAMES.PAYMENT.toLowerCase()}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="flex items-center mb-6">
        <SmartBackButton
          fallbackPath="/payments"
          className="text-link hover:text-hover flex items-center"
        />
      </div>

      {/* Form */}
      <div className="bg-white shadow-sm rounded-lg border border-neutral-200 overflow-hidden">
        <div className="p-6">
          <div className="flex justify-between items-start mb-6">
            <h1 className="">Add {ENTITY_NAMES.PAYMENT}</h1>
          </div>

          <PaymentForm onSubmit={handleSubmit} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default AddPayment;
